export const wordCategories = {
  Animals: [
    'Elephant', 'Kangaroo', 'Cheetah', 'Giraffe', 'Dolphin',
    'Penguin', 'Zebra', 'Tiger', 'Octopus', 'Panda',
    'Lion', 'Koala', 'Peacock', 'Camel', 'Hippopotamus',
    'Crocodile', 'Whale', 'Rabbit', 'Wolf', 'Ostrich',
    'Fox', 'Sloth', 'Otter', 'Squirrel', 'Alligator',
    'Moose', 'Bat', 'Seal', 'Jellyfish', 'Antelope',
    'Flamingo', 'Parrot', 'Raccoon', 'Beaver', 'Hawk'
  ],
  Movies: [
    'Inception', 'Titanic', 'Avatar', 'Joker', 'Interstellar',
    'Gladiator', 'The Matrix', 'Frozen', 'The Godfather', 'Avengers',
    'Forrest Gump', 'The Lion King', 'Pulp Fiction', 'Black Panther', 'The Dark Knight',
    'Finding Nemo', 'Toy Story', 'Shrek', 'Star Wars', 'La La Land',
    'Up', 'Monsters Inc.', 'The Shawshank Redemption', 'Endgame', 'WALL-E',
    'The Incredibles', 'Zootopia', 'Harry Potter', 'Coco', 'Encanto',
    'Despicable Me', 'The Hunger Games', 'The Maze Runner', 'Frozen 2', 'Minions'
  ],
  Food: [
    'Pizza', 'Burger', 'Pasta', 'Ice Cream', 'Sushi',
    'Tacos', 'Steak', 'Donut', 'Salad', 'Ramen',
    'Sandwich', 'Fried Rice', 'Hot Dog', 'Cupcake', 'Curry',
    'Pancake', 'Burrito', 'Noodles', 'Chips', 'Chocolate',
    'Cheesecake', 'Apple Pie', 'Waffle', 'Chicken Wings', 'Spring Rolls',
    'Lasagna', 'Dumplings', 'Nachos', 'Pudding', 'Bacon',
    'Popcorn', 'Bagel', 'Falafel', 'Quesadilla', 'Tofu'
  ],
  Place: [
    'Paris', 'New York', 'Tokyo', 'London', 'Rome',
    'Dubai', 'Sydney', 'Bangkok', 'Los Angeles', 'Rio de Janeiro',
    'Barcelona', 'Toronto', 'Berlin', 'Moscow', 'Cairo',
    'Venice', 'Istanbul', 'Singapore', 'Amsterdam', 'Cape Town',
    'San Francisco', 'Las Vegas', 'Seoul', 'Honolulu', 'Bali',
    'Mexico City', 'Chicago', 'Mumbai', 'Prague', 'Athens',
    'Hanoi', 'Jakarta', 'Osaka', 'Manila', 'Lisbon'
  ],
  Celebrities: [
    'Taylor Swift', 'Leonardo DiCaprio', 'Oprah Winfrey', 'Tom Hanks', 'Beyoncé',
    'Elon Musk', 'Ariana Grande', 'Dwayne Johnson', 'Angelina Jolie', 'Rihanna',
    'Brad Pitt', 'Justin Bieber', 'Selena Gomez', 'Lady Gaga', 'Kanye West',
    'Emma Watson', 'Cristiano Ronaldo', 'Shakira', 'Chris Hemsworth', 'Zendaya',
    'Billie Eilish', 'Robert Downey Jr.', 'Jennifer Lawrence', 'Ryan Reynolds', 'Kim Kardashian'
  ],
  Sports: [
    'Soccer', 'Basketball', 'Tennis', 'Baseball', 'Golf',
    'Swimming', 'Boxing', 'Cricket', 'Volleyball', 'Hockey',
    'Rugby', 'Skateboarding', 'Skiing', 'Snowboarding', 'Surfing',
    'Wrestling', 'Table Tennis', 'Badminton', 'Cycling', 'Karate',
    'Fencing', 'Gymnastics', 'Archery', 'Bowling', 'Motorsport'
  ],
  Professions: [
    'Doctor', 'Teacher', 'Engineer', 'Chef', 'Pilot',
    'Police Officer', 'Firefighter', 'Artist', 'Musician', 'Actor',
    'Scientist', 'Farmer', 'Mechanic', 'Architect', 'Lawyer',
    'Nurse', 'Pharmacist', 'Librarian', 'Photographer', 'Dentist',
    'Electrician', 'Plumber', 'Journalist', 'Programmer', 'Cashier'
  ],
    Random: [
    'Laptop', 'Rainbow', 'Guitar', 'Galaxy', 'Rocket',
    'Volcano', 'Toothbrush', 'Helmet', 'Puzzle', 'Bicycle',
    'Lantern', 'Suitcase', 'Compass', 'Microscope', 'Clock',
    'Backpack', 'Stapler', 'Camera', 'Scissors', 'Paintbrush',
    'Candle', 'Snowman', 'Submarine', 'Headphones', 'Drone',
    'Keyboard', 'Telephone', 'Anchor', 'Lighthouse', 'Boomerang',
    'Mirror', 'Wallet', 'Key', 'Telescope', 'Umbrella'
  ]
};
